/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
  FormInput,
  FormItemContainer,
  FormRadioItem,
} from "../components/FormInput";
import schoolsApi from "../api/universities";

const Profile = ({
  user,
  update,
  updatePassword,
  updateEmailPreferences,
  errorMessage,
  clearErrorMessage,
}) => {
  const [editing, setEditing] = useState(false);
  const [passwordEditing, setPasswordEditing] = useState(false);
  const [firstName, setFirstName] = useState(user.first_name);
  const [lastName, setLastName] = useState(user.last_name);
  const [title, setTitle] = useState(user.title);
  const [university_name, set_university_name] = useState(user.university_name);
  const [university, set_university] = useState(user.university);
  const [newsletter, setNewsLetter] = useState(user.newsletter);
  const [schoolList, setSchoolList] = useState([]);
  const [filteredSchoolList, setfilteredSchoolList] = useState([]);
  const [schoolListVisible, setSchoolListVisible] = useState(false);
  const [filtering, setFiltering] = useState(false);
  const [schoolChosenFromList, setSchoolChosenFromList] = useState(false);
  const [department, setDepartment] = useState(user.department);
  const [email, setEmail] = useState(user.email);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [newPasswordConfirm, setNewPasswordConfirm] = useState("");
  const [profileUpdateConfirmed, setProfileUpdateConfirmed] = useState(false);
  const [passwordUpdateConfirmed, setPasswordUpdateConfirmed] = useState(false);
  const [passwordFormValidated, setPasswordFormValidated] = useState(false);
  const [newsletterUpdateConfirmed, setNewsLetterUpdateConfirmed] =
    useState(false);

  const passwordFormatErrorMessage =
    "Your password must contain 8-32 characters, one uppercase letter, one lowercase letter, one number, and one special character (@!%*?&).";

  const passwordFormatNotMatchingErrorMessage = "Passwords do not match.";

  const currentPasswordIncorrectErrorMessage =
    "Your current password is incorrect.";

  const newPasswordMatchesOldErrorMessage =
    "Your new password should not match your current password.";

  const profileUpdateMessage = "Profile updated successfully.";

  const passwordUpdateMessage = "Password updated successfully.";

  const newsletterUpdateConfirmedMessage = "Email preferences updated.";

  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,32}$/;

  const checkPasswordFormValidity = (
    currentPassword,
    newPassword,
    newPasswordConfirm
  ) => {
    if (
      currentPassword !== newPassword &&
      passwordRegex.test(newPassword) &&
      newPassword === newPasswordConfirm
    ) {
      setPasswordFormValidated(true);
    } else {
      setPasswordFormValidated(false);
    }
  };

  const saveUserData = () => {
    const updatedData = update({
      first_name: firstName,
      last_name: lastName,
      title,
      email,
      university,
      university_name,
    });
    setEditing(false);
    if (updatedData) {
      setProfileUpdateConfirmed(true);
      setTimeout(() => {
        setProfileUpdateConfirmed(false);
      }, "5000");
      setSchoolChosenFromList(false);
      setSchoolListVisible(false);
    }
  };

  const selectSchoolFromList = (e) => {
    const value = e.target.innerText;
    const id = e.target.getAttribute("id");
    set_university_name(value);
    set_university(id);
    setSchoolChosenFromList(true);
    setSchoolListVisible(false);
  };

  const fetchSchoolList = () => {
    schoolsApi
      .get("/university_names/")
      .then((res) => {
        const { data } = res;
        setSchoolList(data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const filterSchoolList = () => {
    if (university_name.length > 0) {
      const valueMatch = Array.from(university_name).reduce(
        (a, v, i) => `${a}[^${university_name.substr(i)}]*?${v}`,
        ""
      );
      const valueRegEx = RegExp(valueMatch, "i");
      let filteredList = schoolList
        .filter((school) => {
          return school.name.match(valueRegEx);
        })
        .sort();
      setfilteredSchoolList(filteredList);
      setSchoolListVisible(true);
      setFiltering(false);
    } else {
      setfilteredSchoolList([]);
    }
  };

  const savePasswordChange = async () => {
    const updatedPassword = await updatePassword({
      id: user.id,
      current_password: currentPassword,
      new_password: newPassword,
      new_password_2: newPasswordConfirm,
    });
    if (updatedPassword === true) {
      clearErrorMessage();
      setCurrentPassword("");
      setNewPassword("");
      setNewPasswordConfirm("");
      setPasswordEditing(false);
      setPasswordUpdateConfirmed(true);
      setTimeout(() => {
        setPasswordUpdateConfirmed(false);
      }, "5000");
    }
  };

  const saveEmailPreferences = async () => {
    const updatedEmailPreferences = await updateEmailPreferences({
      id: user.id,
      newsletter,
    });
    if (updatedEmailPreferences === true) {
      setNewsLetterUpdateConfirmed(true);
      setTimeout(() => {
        setNewsLetterUpdateConfirmed(false);
      }, "5000");
    }
  };

  useEffect(() => {
    const checkPasswordFormInterval = setTimeout(() => {
      checkPasswordFormValidity(
        currentPassword,
        newPassword,
        newPasswordConfirm
      );
    }, 500);

    const filterSchoolsTimer = setTimeout(() => {
      if (university_name.length > 0 && !schoolChosenFromList) {
        setFiltering(true);
        filterSchoolList();
      }
    }, 500);

    return () => {
      clearTimeout(checkPasswordFormInterval);
      clearTimeout(filterSchoolsTimer);
    };
  }, [
    currentPassword,
    newPassword,
    newPasswordConfirm,
    university_name,
    schoolChosenFromList,
  ]);

  useEffect(() => {
    fetchSchoolList();
  }, []);

  return (
    <div className="px-10 py-3">
      <div className="pb-10 border-b-2 border-coolGray-300">
        <div className="flex items-center">
          <h3 className="p-0">Account Information</h3>
          {profileUpdateConfirmed && (
            <h3 className="ml-3 p-0 text-semibold text-emerald-500">
              {profileUpdateMessage}
            </h3>
          )}
        </div>
        <div className="flex justify-start items-center">
          <p className="font-semibold">First Name: </p>
          {!editing ? (
            <p>{user.first_name}</p>
          ) : (
            <div className="ml-3 flex">
              <FormInput
                type="text"
                placeHolderText={firstName}
                value={firstName}
                name="textInput"
                onChange={(e) => setFirstName(e.target.value)}
              />
            </div>
          )}
        </div>
        <div className="flex justify-start items-center">
          <p className="font-semibold">Last Name: </p>
          {!editing ? (
            <p>{user.last_name}</p>
          ) : (
            <div className="ml-3 flex">
              <FormInput
                type="text"
                placeHolderText={lastName}
                value={lastName}
                name="textInput"
                onChange={(e) => setLastName(e.target.value)}
              />
            </div>
          )}
        </div>
        <div className="flex justify-start items-center">
          <p className="font-semibold">Title: </p>
          {!editing ? (
            <p>{user.title}</p>
          ) : (
            <div className="ml-3 flex">
              <FormInput
                type="text"
                placeHolderText={title}
                value={title}
                name="textInput"
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>
          )}
        </div>
        <div className="flex justify-start items-center">
          <p className="font-semibold">University: </p>
          {!editing ? (
            <p>
              {!schoolChosenFromList ? user.university_name : university_name}
            </p>
          ) : (
            <div className="ml-3 flex relative">
              <FormInput
                type="text"
                placeHolderText={
                  filtering === true ? "filtering..." : university_name
                }
                value={university_name}
                name="textInput"
                id={user.university}
                onChange={(e) => {
                  set_university_name(e.target.value);
                  set_university(e.target.getAttribute("id"));
                }}
                onFocus={() => setSchoolListVisible(false)}
                onBlur={() => setFiltering(false)}
              />
              {schoolListVisible && (
                <div className="min-w-max-content w-96 absolute top-12 left-0 h-auto overflow-hidden shadow-lg rounded-lg bg-white z-50">
                  <div className="h-full w-full max-h-40 overflow-y-auto flex flex-col">
                    {filteredSchoolList.map((school) => {
                      const { id, name } = school;
                      return (
                        <div
                          onClick={(e) => selectSchoolFromList(e)}
                          id={id}
                          className="bg-white p-2 items-center hover:bg-blue-500 hover:text-white hover:font-bold"
                          key={id}
                        >
                          {name}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
        <div className="flex justify-start items-center">
          <p className="font-semibold">Department or school: </p>
          {!editing ? (
            <p>{user.department}</p>
          ) : (
            <div className="ml-3 flex">
              <FormInput
                type="text"
                placeHolderText={department}
                value={department}
                name="textInput"
                onChange={(e) => setDepartment(e.target.value)}
              />
            </div>
          )}
        </div>
        <div className="flex justify-start items-center">
          <p className="font-semibold">Email: </p>
          {!editing ? (
            <p>{user.email}</p>
          ) : (
            <div className="ml-3 flex">
              <FormInput
                type="text"
                placeHolderText={email}
                value={email}
                name="textInput"
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          )}
        </div>
        <div>
          {!editing ? (
            <button
              onClick={() => setEditing(true)}
              className="py-2 px-5 mr-5 text-white bg-dms-primary text-lg font-medium cursor-pointer transition duration-100 rounded z-10 hover:text-coolGray-100 hover:bg-blue-500"
            >
              Edit profile
            </button>
          ) : (
            <div>
              <button
                onClick={() => setEditing(false)}
                className="py-2 px-5 mr-5 text-white bg-dms-primary text-lg font-medium cursor-pointer transition duration-100 rounded z-10 hover:text-coolGray-100 hover:bg-blue-500"
              >
                Cancel
              </button>
              <button
                onClick={() => saveUserData()}
                className="py-2 px-5 mr-5 text-white bg-dms-primary text-lg font-medium cursor-pointer transition duration-100 rounded z-10 hover:text-coolGray-100 hover:bg-blue-500"
              >
                Save
              </button>
            </div>
          )}
        </div>
      </div>
      <div className="mb-10 border-b-2 border-coolGray-300">
        <div className="mt-5 flex items-center">
          <h3 className="p-0">Account security</h3>
          {passwordUpdateConfirmed && (
            <h3 className="ml-3 p-0 text-semibold text-emerald-500">
              {passwordUpdateMessage}
            </h3>
          )}
        </div>
        {!passwordEditing ? (
          <div className="mt-5 flex justify-start items-center">
            <p className="font-semibold">Password</p>
            <p>*********</p>
          </div>
        ) : (
          <div className="mt-5">
            <div className="flex justify-start items-center">
              <div className="my-5">
                <form className="relative">
                  <label className="font-semibold mb-1 mr-1 text-coolGray-600 block z-10 whitespace-nowrap w-full">
                    Current Password
                    <input
                      className="block w-full border-coolGray-200 rounded-lg shadow-lg mt-2"
                      type="password"
                      value={currentPassword}
                      name="password"
                      onChange={(e) => setCurrentPassword(e.target.value)}
                    />
                  </label>
                </form>
              </div>
              {errorMessage === "Your current password is incorrect" && (
                <div className="pt-5 flex space-x-5">
                  <p className="py-0 ml-3 text-red-400">
                    {currentPasswordIncorrectErrorMessage}
                  </p>
                  <a
                    className="text-dms-primary font-bold hover:cursor-pointer hover:underline"
                    href="/forgot_password"
                  >
                    Forgot password?
                  </a>
                </div>
              )}
            </div>
            <div className="flex justify-start items-center">
              <div className="my-5 flex">
                <form className="relative">
                  {!showPassword ? (
                    <svg
                      fill="none"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      className="absolute left-1 bottom-0 transform -translate-y-3 text-coolGray-400"
                      onClick={(e) => setShowPassword(!showPassword)}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                      />
                    </svg>
                  ) : (
                    <svg
                      fill="none"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      className="absolute left-1 bottom-0 transform -translate-y-3 text-coolGray-400"
                      onClick={(e) => setShowPassword(!showPassword)}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
                      />
                    </svg>
                  )}
                  <label className="font-semibold mb-1 mr-1 text-coolGray-600 block z-10 whitespace-nowrap w-full">
                    New Password
                    <input
                      className="block w-full border-coolGray-200 rounded-lg shadow-lg pl-10 mt-2"
                      type={!showPassword ? "password" : "text"}
                      value={newPassword}
                      name="newPassword"
                      onChange={(e) => setNewPassword(e.target.value)}
                    />
                  </label>
                </form>
              </div>
              {!passwordRegex.test(newPassword) && (
                <p className="ml-3 text-red-400">
                  {passwordFormatErrorMessage}
                </p>
              )}
              {currentPassword === newPassword && (
                <p className="ml-3 text-red-400">
                  {newPasswordMatchesOldErrorMessage}
                </p>
              )}
            </div>
            <div className="flex justify-start items-center">
              <div className="my-5 flex">
                <form className="relative">
                  {!showPassword ? (
                    <svg
                      fill="none"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      className="absolute left-1 bottom-0 transform -translate-y-3 text-coolGray-400"
                      onClick={(e) => setShowPassword(!showPassword)}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                      />
                    </svg>
                  ) : (
                    <svg
                      fill="none"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      className="absolute left-1 bottom-0 transform -translate-y-3 text-coolGray-400"
                      onClick={(e) => setShowPassword(!showPassword)}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
                      />
                    </svg>
                  )}
                  <label className="font-semibold mb-1 mr-1 text-coolGray-600 block z-10 whitespace-nowrap w-full">
                    Confirm New Password
                    <input
                      className="block w-full border-coolGray-200 rounded-lg shadow-lg pl-10 mt-2"
                      type={!showPassword ? "password" : "text"}
                      value={newPasswordConfirm}
                      name="newConfirmPassword"
                      onChange={(e) => setNewPasswordConfirm(e.target.value)}
                    />
                  </label>
                </form>
              </div>
              {newPassword !== newPasswordConfirm && (
                <p className="ml-3 text-red-400">
                  {passwordFormatNotMatchingErrorMessage}
                </p>
              )}
            </div>
          </div>
        )}
        <div className="pb-10">
          {!passwordEditing ? (
            <button
              onClick={() => setPasswordEditing(true)}
              className="py-2 px-5 mr-5 text-white bg-dms-primary text-lg font-medium cursor-pointer transition duration-100 rounded z-10 hover:text-coolGray-100 hover:bg-blue-500"
            >
              Change password
            </button>
          ) : (
            <div>
              <button
                onClick={() => {
                  setPasswordEditing(false);
                  setCurrentPassword("");
                  setNewPassword("");
                  setNewPasswordConfirm("");
                }}
                className="py-2 px-5 mr-5 text-white bg-dms-primary text-lg font-medium cursor-pointer transition duration-100 rounded z-10 hover:text-coolGray-100 hover:bg-blue-500"
              >
                Cancel
              </button>
              <button
                onClick={() => savePasswordChange()}
                disabled={!passwordFormValidated}
                className={`py-2 px-5 mr-5 text-white bg-dms-primary text-lg font-medium cursor-pointer transition duration-100 rounded z-10 hover:text-coolGray-100 hover:bg-blue-500 ${
                  !passwordFormValidated
                    ? " opacity-50 cursor-not-allowed hover:"
                    : "hover:text-coolGray-100 hover:bg-blue-500"
                }`}
              >
                Save
              </button>
            </div>
          )}
        </div>
      </div>
      <div>
        <div className="flex items-center">
          <h3 className="p-0">Email preferences</h3>
          {newsletterUpdateConfirmed && (
            <h3 className="ml-3 p-0 text-semibold text-emerald-500">
              {newsletterUpdateConfirmedMessage}
            </h3>
          )}
        </div>
        <div className="pt-5">
          <FormItemContainer labelText="Receive emails about sim updates and events?">
            <FormRadioItem
              type="radio"
              placeholder="Sample Radio"
              value={true}
              checked={newsletter}
              name="newsletter"
              onChange={() => setNewsLetter(true)}
              spanText="Yes"
            />
            <FormRadioItem
              type="radio"
              placeholder="Sample Radio"
              value={false}
              checked={!newsletter}
              name="newsletter"
              onChange={() => setNewsLetter(false)}
              spanText="No"
            />
          </FormItemContainer>
        </div>
        <button
          onClick={() => {
            saveEmailPreferences();
          }}
          className="py-2 px-5 mr-5 text-white bg-dms-primary text-lg font-medium cursor-pointer transition duration-100 rounded z-10 hover:text-coolGray-100 hover:bg-blue-500"
        >
          Change preferences
        </button>
      </div>
    </div>
  );
};

export default Profile;
